(function () {
  var timer;

  function getSizeSelect(product) {
    return product.querySelector('select[name^="options[Size]"]') ||
      product.querySelector('select[name*="[Size]"]');
  }

  function getSizeState(product) {
    var select = getSizeSelect(product);
    if (!select || !select.value) return 'blank';
    var option = select.options[select.selectedIndex];
    return option && /unavailable|sold out/i.test(option.textContent) ? 'unavailable' : 'available';
  }

  function syncAvailability() {
    document.querySelectorAll('product-info').forEach(function (product) {
      if (!getSizeSelect(product)) return;
      var state = getSizeState(product);
      product.querySelectorAll('.price').forEach(function (price) {
        price.classList.toggle('price--sold-out', state === 'unavailable');
      });
      product.querySelectorAll('.price__badge, .price__badge-sold-out, .price__badge-sold_out').forEach(function (badge) {
        var show = state === 'unavailable';
        badge.hidden = !show;
        if (show) badge.removeAttribute('aria-hidden');
        else badge.setAttribute('aria-hidden', 'true');
      });
      product.querySelectorAll('button[name="add"], .product-form__submit').forEach(function (button) {
        // Only product-info may enable submission, after its variant request finishes.
        // A selected size alone does not mean the form's variant ID is ready.
        if (state !== 'available') button.disabled = true;
        button.classList.toggle('disabled', button.disabled);
        if (state === 'available') return;
        var label = state === 'blank' ? 'Select a Size' : 'Sold out';
        var buttonText = button.querySelector('span');
        if (buttonText && buttonText.textContent.trim() !== label) buttonText.textContent = label;
      });
    });
  }

  function schedule() {
    window.clearTimeout(timer);
    timer = window.setTimeout(syncAvailability, 40);
  }

  document.addEventListener('DOMContentLoaded', function () {
    syncAvailability();
    new MutationObserver(schedule).observe(document.body, {childList:true, subtree:true});
  });
  document.addEventListener('change', schedule);
  window.addEventListener('load', syncAvailability);
  syncAvailability();
})();
